import { useEffect } from 'react';

function upsertMetaAttribute(selector, attribute, value) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    const match = selector.match(/\[(name|property)="([^"]+)"\]/);
    if (match) {
      element.setAttribute(match[1], match[2]);
    }
    document.head.appendChild(element);
  }
  element.setAttribute(attribute, value);
}

function PageMeta({ title, description }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMetaAttribute('meta[property="og:title"]', 'content', title);
    }

    if (description) {
      upsertMetaAttribute('meta[name="description"]', 'content', description);
      upsertMetaAttribute('meta[property="og:description"]', 'content', description);
    }
  }, [title, description]);

  return null;
}

export default PageMeta;